import React from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export function CheckMarkOutlineIcon() {
  return _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94976 16.1421L5.70712 11.8995L4.29291 13.3137L9.94976 18.9706L21.2635 7.65687L19.8493 6.24265L9.94976 16.1421Z"
  });
}
export function MinusOutlineIcon() {
  return _jsx("path", {
    d: "M20 12a1 1 0 01-1 1H5a1 1 0 110-2h14a1 1 0 011 1z"
  });
}